// Comprehensive polyfills for production build compatibility

// Ensure Array methods are available
const arrayMethods = ['some', 'every', 'find', 'findIndex', 'includes', 'flat', 'flatMap'];

arrayMethods.forEach(method => {
  if (typeof Array.prototype[method as keyof Array<any>] !== 'function') {
    console.warn(`Array.${method} is not available, adding polyfill`);
  }
});

// Ensure proper global object
if (typeof globalThis === 'undefined') {
  (window as any).globalThis = window;
}

// Ensure proper Promise support
if (typeof Promise === 'undefined') {
  console.warn('Promise is not supported in this environment');
}

// Fix for Ant Design specific issue
// The error suggests that 'ee' is not an array, so we need to ensure it's properly handled
Object.defineProperty(Array.prototype, 'some', {
  value: function(callback: any, thisArg: any) {
    if (this == null) {
      throw new TypeError('Array.prototype.some called on null or undefined');
    }
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }
    const t = Object(this);
    const len = t.length >>> 0;
    for (let i = 0; i < len; i++) {
      if (i in t && callback.call(thisArg, t[i], i, t)) {
        return true;
      }
    }
    return false;
  },
  writable: true,
  configurable: true
});

// Ensure Object methods are available
if (typeof Object.entries !== 'function') {
  Object.entries = function(obj: any) {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}

// Ensure String methods are available
if (typeof String.prototype.startsWith !== 'function') {
  String.prototype.startsWith = function(searchString: string, position?: number) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (typeof String.prototype.endsWith !== 'function') {
  String.prototype.endsWith = function(searchString: string, length?: number) {
    if (length === undefined || length > this.length) {
      length = this.length;
    }
    return this.substring(length - searchString.length, length) === searchString;
  };
}

// Specific fix for Ant Design error: ensure any object that should be an array is handled
// This is a more aggressive approach to catch the specific error
const originalSome = Array.prototype.some;
Array.prototype.some = function(callback: any, thisArg: any) {
  // If 'this' is not an array-like object, try to convert it
  if (this == null) {
    console.warn('Array.some called on null/undefined, attempting to handle gracefully');
    return false;
  }
  
  // If 'this' is not array-like, try to make it work
  if (typeof this !== 'object' || typeof this.length !== 'number') {
    console.warn('Array.some called on non-array object, attempting to handle gracefully');
    return false;
  }
  
  // Call the original method
  return originalSome.call(this, callback, thisArg);
};

export {};
